import { render } from "./Widgets.vue?vue&type=template&id=113e612b&scoped=true"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"

import "./Widgets.vue?vue&type=style&index=0&id=113e612b&lang=scss&scoped=true"
import "./Widgets.vue?vue&type=style&index=1&id=113e612b&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113e612b"]])

export default __exports__